import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"

const initialState: {
  composite: {
    breadCrumbId: number
    data: filteredUsersType[]
  }
  benchmark: {
    breadCrumbId: number
    data: filteredUsersType[]
    measureId: string
  }
  compositeId: string
} = {
  composite: {
    breadCrumbId: 0,
    data: [],
  },
  benchmark: {
    breadCrumbId: 0,
    data: [],
    measureId: "",
  },
  compositeId: "",
}

type filteredUsersType = {
  email: string
  name: string
  groupName: string
  userId: number
  runId: number
  organizationId: number
  B1: number
  B1_output_score: number
  B2: number
  B2_output_score: number
  B3: number
  B3_output_score: number
  B4: number
  B4_output_score: number
  B5: number
  B5_output_score: number
  B6: number
  B6_output_score: number
  B7: number
  B7_output_score: number
  B8: number
  B8_output_score: number
  G1: number
  G1_output_score: number
  G2: number
  G2_output_score: number
  G3: number
  G3_output_score: number
  G4: number
  G4_output_score: number
  G5: number
  G5_output_score: number
  G6: number
  G6_output_score: number
  cplan_count: number
  connections_count: number
  eplan_count: number
  total_connections: number
  rawScoresTotal: number
  compositeScoresTotal: number
  final_Total: number
  raw_total: number
}

export const recruiterSlice = createSlice({
  name: "recruiter",
  initialState,
  reducers: {
    updateComposite(
      state,
      action: PayloadAction<{
        breadCrumbId: number
        data: filteredUsersType[]
        compositeId: string
      }>,
    ) {
      console.log("action.payload", action.payload, state)
      state.composite.data = action.payload.data
      state.composite.breadCrumbId = action.payload.breadCrumbId
      state.compositeId = action.payload.compositeId
    },
    updateBenchmark(
      state,
      action: PayloadAction<{
        breadCrumbId: number
        data: filteredUsersType[]
        measureId: string
        compositeId: string
      }>,
    ) {
      console.log("updateBenchmark", state)
      state.benchmark.data = action.payload.data
      state.benchmark.breadCrumbId = action.payload.breadCrumbId
      state.benchmark.measureId = action.payload.measureId
      state.compositeId = action.payload.compositeId
    },
    setCompositeId(state, action: PayloadAction<string>) {
      state.compositeId = action.payload
    },
  },
})

const persistConfig = {
  key: "recruiter",
  storage,
  whitelist: [""],
}

export const recruiterSliceReducer = persistReducer(
  persistConfig,
  recruiterSlice.reducer,
)

export const { updateComposite, updateBenchmark, setCompositeId } =
  recruiterSlice.actions

export default recruiterSlice.reducer
